import React from 'react'
import '../css/nav.css'

const Navigation = () => {
  return (
    <nav>
      <ul>
        <li><a className='anchor-hover' href='https://www.dangrygames.uk/index.html'>Home</a></li>
        <li><a className='anchor-hover' href='https://www.dangrygames.uk/halfbrick.html'>Halfbrick</a></li>
        <li><a className='anchor-hover' href='https://www.dangrygames.uk/solo.html'>Solo</a></li>
        <li><a className='anchor-hover' href='https://www.dangrygames.uk/blog.html'>Blog</a></li>
        <li><a className='anchor-hover' href='https://www.dangrygames.uk/contact.html'>Contact</a></li>
      </ul>
    </nav>
  )
}

export default Navigation
